export default {
    AfriendPhone: 'Um amigo Número de telefone:',
    wheelget: `Clique na roleta para obter`,
    KSH: 'R$',
    takeout: `Levar`,
    only: `Basta conseguir outro `,
    towithdraw: `para sacar`,
    Expira: `Tempo de expiração`,
    Invite: `Convide amigos para ajudá-lo a sacar`,
    allbets: `Bônus recebido`,
    Leaderboard: `Detalhes do convite`,
    rank: `Classificação`,
    user: `Usuário`,
    betamount: `Valor apostado`,
    pddDesc: `Regras do evento`,
    pddDesc1: `1. O valor acumulado atinge`,
    pddDesc2: `2. Convide seus amigos para se registrarem no 999YES, isso o ajudará a sacar dinheiro mais rapidamente. Se seu amigo se registrar e jogar, ajudará ainda mais.`,
    pddDesc3: `3. Cada usuário recebe uma rodada grátis por dia.`,
    pddDesc4: `4. Cada usuário é válido por 3 dias por evento e pode participar várias vezes.`,
    pddDesc5: `5. Se você for recompensado com o valor do evento, poderá jogar gratuitamente e ganhar mais dinheiro real.`,
    pddDesc6: `6. Se o saque não for feito dentro de 3 dias, o dinheiro será perdido.`,
    GetKsh: 'Obtenha R$',
    frofree: 'grátis',
    SACAR: 'SACAR',
    takewrong: `caso contrário`,
    FRIENDEARN: 'AJUDE UM AMIGO A GANHAR',
    Afterregistering: 'Após o registro, você pode participar de atividades para ganhar XAF',
    aftersign: `Após o login, você também pode participar do evento para ganhar`,
    invitedyou: `convidou você para participar do evento e ganhar`,
    helphim: `Faça login para ajudá-lo a ganhar`,
    Helpfriend: 'Ajude um amigo a ganhar',
    youfriend: 'Seu amigo',
    pleasetry: `por favor, tente novamente`,
}